<template>
  <v-app>
    <Unmenu />
    <div class="main mt-16 pt-10">
      <div class="rows">
        <div class="d-flex align-center align-self-center justify-space-between my-16">
          <div class="pic">
            <img class="size" src="../assets/whatsapp.png" alt="">
            <div class="h1">WhatsApp :</div>
            <div class="redtext">{{ $t("contact.phone1") }}</div>
            <div class="redtext">{{ $t("contact.phone2") }}</div>
          </div>
          <div class="pic">
            <img class="size" src="../assets/email.png" alt="">
            <div class="h1">Email :</div>
            <div class="redtext">{{ $t("contact.email") }}</div>
          </div>
        </div>
      </div>
      <div class="pub1">
        <img src="../assets/pub1.png" class="size">
      </div>
      <div class="pub2">
        <img src="../assets/pub2.png" class="size">
      </div>
      <div class="pub3">
        <img src="../assets/pub3.png" class="size">
      </div>
      <div class="foot mt-16 mb-4">
        <div class="footext">{{ $t("contact.info") }}</div>
      </div>
    </div>
  </v-app>
</template>
<script>
import Unmenu from '../components/unmenu.vue'
export default {
  components: {
    Unmenu
  }
}
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  .rows {
    height: 60vh;
    width: 60%;
    margin: 0 auto;
    .pic {
      text-align: center;
      width: 30%;
      .size {
        width: 100%;
      }
      .h1 {
        font-size: 36px;
        font-family: Roboto, Roboto-Black;
        font-weight: 900;
        text-align: center;
        color: #182639;
        line-height: 40px;
      }
      .redtext {
        font-size: 18px;
        font-family: Roboto, Roboto-Bold;
        font-weight: 700;
        text-align: center;
        color: #ff0300;
        line-height: 24px;
      }
    }
  }
  .pub1 {
    position: absolute;
    bottom: 0;
    left: 0;
    .size{
      width: 240px;
    }
  }
  .pub2 {
    position: absolute;
    bottom: 5rem;
    right: 1rem;
    .size{
      width: 80px;
    }
  }
  .pub3 {
    position: absolute;
    top: 1rem;
    right: 0;
    .size{
      width: 156px;
    }
  }
  .foot {
    .footext {
      font-size: 14px;
      font-family: Roboto, Roboto-Medium;
      font-weight: 500;
      color: #9dabbb;
      line-height: 20px;
      text-align: center;
    }
  }
}
</style>
